import {h, Fragment} from "preact"
import { useAppState, HistoryElement } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks";
import { defaultConfig, popularSearches } from "../config"
import { closeSearchOverlay } from "../helpers"

export default function () {
    const { historyItems } = useAppState();
    const [ recId, setRecId ] = useState(null);
    const autocompleteRef = useRef(null);

    useEffect(() => {
        setRecId(!!autocompleteRef.current.closest('#serp-searchbar') ? "serpdropdown-nosto-1" : "searchdropdown-nosto-1" )
    }, [ autocompleteRef ])

    useEffect(() => {
        if(window.nostojs && recId) {
            window.nostojs(api => {
                api
                 .createRecommendationRequest({ includeTagging: true })
                 .addElements([recId])
                 .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [ recId ])

    const handleKeywordClick = (e) => {
        if(e.target.closest('.ns-autocomplete-element')) {
            closeSearchOverlay();
        }
    }

    return (
        <div 
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            ref={autocompleteRef}
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    <div class="nosto_element ns-autocomplete-products ns-d-flex ns-flex-row ns-flex-wrap ns-flex-md-nowrap" id={recId ? recId : ''}></div>
                    
                    <div class="ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ns-col-sm-3">
                        {/* <div class="ns-px-4 ns-py-2 ns-font-6 ns-text-underline">Recently Searched</div> */}
                        <div class="ns-d-flex ns-flex-column" onClick={handleKeywordClick}>
                            <h3 class="ns-keyword-heading ns-pt-0">Previous Searches</h3>
                            {historyItems
                                ?.slice(0, defaultConfig.historySize)
                                .map(item => (
                                    <HistoryElement key={item} query={{ query: item }}>
                                        <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                            {item}
                                        </div>
                                    </HistoryElement>
                            ))}
                        </div>

                        <div class="ns-d-flex ns-flex-column" onClick={handleKeywordClick}>
                            <h3 class="ns-keyword-heading">Collections</h3>
                            {popularSearches.map(search => (
                                search.url ? (
                                    <a 
                                        key={search.text}
                                        class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4" 
                                        href={search.url}
                                        onClick={() => location.href = search.url} /* some event listener is blocking regular navigation */
                                    >
                                        {search.text}
                                    </a>
                                ) : (
                                    <HistoryElement key={search.text} query={{ query: search.text }}>
                                        <div class="ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-2 ns-px-4 ns-font-4">
                                            {search.text}
                                        </div>
                                    </HistoryElement>
                                )
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}